import React, { FC } from 'react';
import {
  VStack,
  Text,
  useMultiStyleConfig,
  Box,
  BoxProps,
  SystemStyleObject,
} from '@chakra-ui/react';

export interface ChakraEmptyListProps extends BoxProps {
  icon?: React.ReactNode;
  title: string;
  primaryText: React.ReactNode;
  primaryTextSx?: SystemStyleObject;
  secondaryText?: string;
  secondaryTextSx?: SystemStyleObject;
  titleSx?: SystemStyleObject;
  overrideText?: string;
}

export const ChakraEmptyList: FC<ChakraEmptyListProps> = ({
  icon,
  title,
  primaryText,
  primaryTextSx,
  secondaryText,
  secondaryTextSx,
  overrideText,
  titleSx,
  children,
  ...rest
}) => {
  const styles = useMultiStyleConfig('EmptyList', {
    hasOverride: Boolean(overrideText),
  });
  return (
    <VStack
      sx={styles}
      justifyContent="center"
      spacing="0"
      height="100%"
      {...rest}
    >
      {overrideText ? (
        <Text sx={styles.text} data-testid="empty-list-message">
          {overrideText}
        </Text>
      ) : (
        <>
          {icon && <Box sx={styles.icon}>{icon}</Box>}
          <Text
            sx={{
              ...styles.title,
              ...titleSx,
            }}
            data-testid="empty-list-title"
          >
            {title}
          </Text>
          <Text
            sx={{
              ...styles.text,
              ...primaryTextSx,
            }}
            data-testid="empty-list-message"
          >
            {primaryText}
          </Text>
          {secondaryText && (
            <Text
              sx={{
                ...styles.text,
                ...secondaryTextSx,
              }}
              data-testid="empty-list-message"
            >
              {secondaryText}
            </Text>
          )}
        </>
      )}
      {children}
    </VStack>
  );
};
